// Webpack Imports
//import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

	if (!document.body.classList.contains("home") && !document.body.classList.contains("page-template-contactos") && !document.body.classList.contains("page-template-equipa")) {
		const slideshowContent = document.querySelector('.slideshow__content');
		if (slideshowContent) {
			if (window.innerWidth > 991) {
				var hero = gsap.timeline({
				  scrollTrigger: {
				    trigger: "#main",
				    pin:true,
				    start: "top top",
				    end: "+=290",
				    scrub: true,
				  }
				})
				.to('.slideshow__content',{yPercent:-100});
			}
		}
	}
	//open expand about
	const openLinks = document.querySelectorAll('.expand .open-text');
	openLinks.forEach((link) => {
	  link.addEventListener('click', (e) => {
	    e.preventDefault();
	    const content = link.parentElement.querySelector('.expand__text');
			const showClose = link.parentElement.querySelector('.close-text');
	    content.style.display = 'block';
			link.style.display = 'none';
			showClose.style.display = 'block';
	  });
	});

	//project timeline hover
	if (document.body.classList.contains("page-template-projeto") && window.innerWidth > 992) {
	  const timelineItems = document.querySelectorAll('.timeline li');
	  timelineItems.forEach(function(item) {
	    if (item.hasAttribute('data-step')) {
	      const stepNumber = item.getAttribute('data-step');
	      const stepElement = document.querySelector('.step' + stepNumber);
	      item.addEventListener('mouseover', function() {
	        stepElement.style.display = 'block';
	      });
	      item.addEventListener('mouseout', function() {
	        stepElement.style.display = 'none';
	      });
	    }
	  });
	}

	//close expand about
	const closeLinks = document.querySelectorAll('.expand .close-text');
	closeLinks.forEach((link) => {
	  link.addEventListener('click', (e) => {
	    e.preventDefault();
	    const content = link.parentElement.querySelector('.expand__text');
			const showOpen = link.parentElement.querySelector('.open-text');
	    content.style.display = 'none';
			link.style.display = 'none';
			showOpen.style.display = 'block';
	  });
	});

	//open faqs
	const faqsElement = document.getElementById("faqs");
	const faqsSelectElement = document.getElementById("faqs-select");
	const openFaqs = document.querySelectorAll('.open-faqs');
	const faqs = document.querySelectorAll('#faqs .container > div');

	openFaqs.forEach((openFaq, index) => {
	  openFaq.addEventListener('click', (e) => {
			e.preventDefault();
	    const faqToDisplay = document.querySelector(`.faqs__${index}`);
			faqsElement.style.display = "block";
			faqsSelectElement.style.display = "none";
	    faqToDisplay.style.display = 'flex';
	  });
	});
	//close faqs
	const closeFaqs = document.getElementById("close-faqs");
	if (closeFaqs) {
		closeFaqs.onclick = function(e) {
			e.preventDefault();
	  	faqsElement.style.display = "none";
			faqsSelectElement.style.display = "block";
			faqs.forEach((faq) => {
				faq.style.display = 'none';
			});
		};
	}

	//tabs
	const elements = document.querySelectorAll('.process__select ul li a');
	const panels = document.querySelectorAll('.process__content > div');
	elements.forEach((element, index) => {
	  element.addEventListener('click', (e) => {
			e.preventDefault();
			elements.forEach((el) => {
	      el.parentElement.classList.remove('active');
	    });

			e.target.parentElement.classList.add('active');

			panels.forEach((pn) => {
	      pn.style.display = 'none';
	    });
	    const elementToDisplay = document.querySelector(`.process__content__${index}`);
	    elementToDisplay.style.display = 'block';
	  });
	});

	//open process
	const targetElement = document.getElementById("process");
	const openProcess = document.getElementById("open-process");
	if (openProcess) {
		openProcess.onclick = function(e) {
			e.preventDefault();
	  	targetElement.style.display = "block";
		};
	}
	//close process
	const closeProcess = document.getElementById("close-process");
	if (closeProcess) {
		closeProcess.onclick = function(e) {
			e.preventDefault();
	  	targetElement.style.display = "none";
		};
	}

	// Get the #about section
	if (document.querySelector("#about")) {
		const aboutSection = document.querySelector("#about");
		const header = document.querySelector("#header");
		const logo = document.querySelector("#logo");
		window.addEventListener("scroll", function() {
		  if (aboutSection.getBoundingClientRect().top <= 0) {
		    header.classList.add("scrolled");
				logo.classList.add("scrolled");
		  } else {
		    header.classList.remove("scrolled");
				logo.classList.remove("scrolled");
		  }
		});
	}

	const swiper = new Swiper('#portfolio', {
		slidesPerView: 1.1,
		spaceBetween: 20,
		loop: true,
	  navigation: {
	    nextEl: '.next-arrow',
	    prevEl: '.prev-arrow',
	  },
	});
	const swiper2 = new Swiper('#slideshow', {
		slidesPerView: 1.3,
		spaceBetween: 20,
		loop: true,
	  navigation: {
	    nextEl: '.arrows-slideshow .next-arrow',
	    prevEl: '.arrows-slideshow .prev-arrow',
	  },
		pagination: {
      el: ".slideshow .swiper-pagination",
      type: "progressbar",
    },
	});

	const swiper4 = new Swiper('#single .swiper', {
		slidesPerView: 1.4,
		spaceBetween: 20,
		loop: true,
		pagination: {
      el: "#single .swiper-pagination",
      type: "progressbar",
    },
	  navigation: {
	    nextEl: '#single .next-arrow',
	    prevEl: '#single .prev-arrow',
	  },
	});

	const swiper3 = new Swiper('#showroom', {
		slidesPerView: 1.2,
		spaceBetween: 15,
		loop: true,
	  navigation: {
	    nextEl: '#showroom .next-arrow',
	    prevEl: '#showroom .prev-arrow',
	  },
		breakpoints: {
      992: {
				slidesPerView: 2.3,
				spaceBetween: 20,
      },
    },
	});

	const swiper33 = new Swiper('#homeSlide .swiper', {
		slidesPerView: 1,
		loop: true,
		autoplay: {
	    delay: 4000,
	  },
	});

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();
